/**
 * Normalise les erreurs IAM login (dont abonnement / billing) pour l'UI Entrea.
 */
export function parseIamLoginFailure(error) {
  const status = error?.response?.status;
  const detail = error?.response?.data?.detail;

  if (detail && typeof detail === 'object' && detail.code) {
    return {
      errorKey: detail.code,
      message: typeof detail.message === 'string' ? detail.message : undefined,
    };
  }

  if (typeof detail === 'string') {
    if (/subscription|billing|expired|abonnement|expir/i.test(detail)) {
      return {
        errorKey: /expir/i.test(detail) ? 'subscription_expired' : 'subscription_inactive',
        message: detail,
      };
    }
    return { message: detail };
  }

  if (Array.isArray(detail)) {
    const text = detail.map((d) => d?.msg || d?.message || String(d)).join(' ');
    return { message: text || undefined };
  }

  if (status === 403 || status === 402) {
    return { errorKey: 'subscription_inactive' };
  }

  if (status >= 500) {
    return { errorKey: 'server_error' };
  }

  return { message: undefined };
}

export function resolveLoginErrorMessage(result, t) {
  if (result?.errorKey) {
    const key = `login.${result.errorKey}`;
    const translated = t(key);
    if (translated && translated !== key) return translated;
  }
  if (result?.error) return result.error;
  return t('login.signInFailed');
}
